import { gql } from '@apollo/client';
export const getAllWithdrawalFeesQuery = gql `
  query GetAllWithdrawalFees {
    getAllWithdrawalFees {
      assetCode
      assetName
      extraConditions {
        destinationBankCode
        destinationNetwork
      }
      blockchainFee
      price
      fixed
      greaterThan
      iconUrl
      id
      isCrypto
      method
      rate
    }
  }
`;
//# sourceMappingURL=getAllWithdrawalFees.js.map